/**=========================================================
 * Module: reference.js
 * Reference Controller
 =========================================================*/


App.controller('ReferenceController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D) {
    "use strict";

    $scope.type = 'reference';
    $scope.id = $state.params.filter;

    $scope.model = {};
    $scope.error = {};
    $scope.page = {
        title: '',
        subTitle: ''
    };


    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function(){

    	if($rootScope.user.id&&( $scope.id != 'undefined')){
            $scope.initialized = true;


            var referentiNames = {};
            var referentiValues = [];
            var gruppiReferenti = [];
            //Carichiamo i valori dei referenti
            //Step 1: carico i tutti gli account di tipo CLIENT
            D.query('group', 'type=SUPPLIER&_withAccounts=true', { cache: false }).then(
            		function(response){
                        //$scope.data = response;
            			//gruppiReferenti=response;
            			var index;
            			var indexRef;
            			var daClient=[];
            			var daReferent=[];
            			for (index = 0; index < response.length; ++index) {
            				daClient = {supplier:response[index].id,supplierName:response[index].name};
            				gruppiReferenti.push(daClient);
            				//referenti[gruppiReferenti[index].code]=gruppiReferenti[index].name;
            				//var myReferGrId=response[index].id;
            				for (indexRef = 0; indexRef < response[index].accounts.length; ++indexRef) {
            					daReferent = {supplierId:response[index].id,referent:response[index].accounts[indexRef].id,referentName:response[index].accounts[indexRef].name};

            					referentiNames[response[index].accounts[indexRef].id]=daReferent;
                			}
            			}
            			$scope.gruppiReferenti=gruppiReferenti;
            			$scope.referentiNames=referentiNames;



            		    D.query('reference', $scope.id, { cache: false }).then(
            		    			function(response){
            		    				$scope.data = response;
            		    				var clientData=$scope.id;
            		    				clientData=clientData.substring(clientData.indexOf("=")+1);
            		                    //$scope.model = model;
            		                    //$scope.page.title = model.name;
            		                    //$scope.page.subTitle = model.code;
            		    				//{ suppliers: [ 'supplierId1', 'supplierId2', ... ], ... eventuali altri campi... }
            		    				var gruppiReferentiClienteIds = {};
            		    				var gruppiSupplierClienteIds = [];
            		    				var gruppiReferentiClienteIdsArray=[];
                                        var referenceCodes = {};
            		    				for (index = 0; index < response.length; ++index) {
            		    					gruppiReferentiClienteIdsArray=[]
            		    					gruppiSupplierClienteIds.push(response[index].supplier);
            		    					gruppiReferentiClienteIdsArray.push(response[index].referent);
            		    					gruppiReferentiClienteIds[response[index].supplier]=gruppiReferentiClienteIdsArray;
                                            referenceCodes[response[index].supplier] = [response[index].code];
            	            			}
            		    				$scope.gruppiSupplierCliente={suppliers:gruppiSupplierClienteIds};
            		    				$scope.referenceCodes=referenceCodes;
            		    				//$scope.gruppiReferenti = response;
            		                    $scope.form = {
            		            		        title: 'labels.EDITSUPPLIERSOFCLIENT',
            		            		        status: '',
            		            		        type: 'reference',
            		            		        model: $scope.gruppiSupplierCliente,
            		            		        fields: [
            		            		            {
            		            		                available: true,
                                                        type: 'checkboxesAndSelect',
                                                        name: 'suppliers',
                                                        selectName:'referents',
                                                        data: $scope.gruppiReferenti,
                                                        valueField: 'supplier',
                                                        labelField: 'supplierName',
                                                        selectModel: gruppiReferentiClienteIds,
                                                        selectData: referentiNames,
                                                        selectSupplierField: 'supplierId',
                                                        selectValueField: 'referent',
                                                        selectLabelField: 'referentName',
                                                        textFieldModel: referenceCodes,
                                                        textField: 'referenceCodes'
            		            		            },{
            		            		                available: false,
            		            		                type: 'text',
            		            		                name: 'referentName',
            		            		                required: true
            		            		            },{
            		            		            	available: true,
            		            		                type: 'separator'
            		            		            },{
            		            		                available: true,
            		            		                type: 'submit',
            		            		                name: 'empty',
            		            		                value: 'fields.SUBMIT'
            		            		            }
            		            		        ],
            		            		        submit: function(){
            		            		            $scope.form.status = 'submitting';
            		            		            //{client:'', references: [{supplier:'',selected:true|false, referent:''},...]}
            		            		            //var objectToPass={client:clientData.toUpperCase(),references:[{supplier:'MMAC',selected:false,referent:'1425629876875868'}]};
            		            		            //il modello è: $scope.gruppiSupplierCliente
            		            		            //data:

            		            		            var referencesToPass=[];
            		            		            for (var contatore = 0; contatore < $scope.gruppiReferenti.length; ++contatore) {
            		            		            	var supToPass=$scope.gruppiReferenti[contatore].supplier;
            		            		            	var selectedToPass=false;
            		            		            	var refToPass='';
            		            		            	var codeToPass='';
            		            		            	for (var contatore2 = 0; contatore2 < $scope.gruppiSupplierCliente.suppliers.length; ++contatore2) {
                		            		            	if($scope.gruppiSupplierCliente.suppliers[contatore2]==supToPass){
                		            		            		selectedToPass=true;
                		            		            		if(gruppiReferentiClienteIds[supToPass]){
                    		            		            		refToPass=gruppiReferentiClienteIds[supToPass][0];
                    		            		            		if(refToPass.length<3){
                    		            		            			refToPass=gruppiReferentiClienteIds[supToPass];
                    		            		            		}
                    		            		            		if(jQuery.isArray(referenceCodes[supToPass])){
                    		            		            			codeToPass=referenceCodes[supToPass][0];
                    		            		            		}else{
                    		            		            			codeToPass=referenceCodes[supToPass];
                    		            		            		}
                    		            		            	}else{
                    		            		            		refToPass='';
                    		            		            	}
                		            		            	}



                            	            			}
            		            		            	if(refToPass!=''){
            		            		            		referencesToPass.push({supplier:supToPass,selected:selectedToPass,referent:refToPass,code:codeToPass});
            		            		            	}else{
            		            		            		referencesToPass.push({supplier:supToPass,selected:selectedToPass});
            		            		            	}

                        	            			}
            		            		            var objectToPass={client:clientData.toUpperCase(),references:referencesToPass};
            		            		           
            		            		            R.one('action','References').customPUT(objectToPass).then(
            		            		                    function(){
            		            		                    	$scope.form.status = 'submitted';
            		            		                    },
            		            		                    function(){
            		            		                        $scope.submitting = false;
            		            		                    }
            		            		                );
            		            		        }
            		            		    };
            		                    //$scope.form.model = $scope.model;

            		                },
            		                function(error){
            		                    $scope.error = error;
            		                }
            		            ).catch(console.error);


            		    /*________________________*/








                    },
                    function(error){
                        $scope.error = error;
                    }
                ).catch(console.error);




    	} else {
            if(!$scope.watchActivated){
                $scope.watchActivated = true;
                $rootScope.$watch('user.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });
            }
        }
    }

    $scope.init();
  }
  ]);
